import { create } from 'zustand';

interface NavigationState {
  isNavigating: boolean;
  targetRoute: string | null;
  setNavigating: (isNavigating: boolean, targetRoute?: string | null) => void;
}

export const useNavigationStore = create<NavigationState>((set) => ({
  isNavigating: false,
  targetRoute: null,
  setNavigating: (isNavigating, targetRoute = null) => set({ isNavigating, targetRoute }),
}));